import React from 'react';
import { MailIcon, ArrowRightIcon } from 'lucide-react';
export const TrustBadges = ({
  showContactForm = true
}) => {
  return <section id="contact" className="bg-[#f2efeb] py-14 md:py-24 border-t border-[#d9d3cb]" data-id="element-619">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-620">
        <div className="bg-[#2b2826] rounded-3xl p-8 sm:p-10 md:p-12 border border-[#403a35]" data-id="element-621">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-622">
            <div data-id="element-623">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 font-serif-display text-[#f2efeb]" data-id="element-624">
                Ready to fund your next deal?
              </h2>
              <p className="text-lg sm:text-xl text-[#f2efeb]/80 mb-8" data-id="element-625">
                Contact our team to discuss your funding needs or to learn more
                about our services. We typically respond within one business
                hour.
              </p>

              <div className="flex items-center text-[#f2efeb]/70 font-light" data-id="element-626">
                <MailIcon className="h-5 w-5 text-[#c9a875] mr-3" data-id="element-627" />
                <span data-id="element-628">support@scalewithlending.com</span>
              </div>
            </div>

            <div className="relative" data-id="element-629">
              <div className="bg-[#2b2826] rounded-3xl p-6 sm:p-8 border border-[#403a35]" data-id="element-630">
                <h3 className="text-2xl font-bold text-[#f2efeb] mb-6" data-id="element-631">
                  Quick Contact
                </h3>
                <form className="space-y-4" data-id="element-632">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-633">
                    <div data-id="element-634">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-1" data-id="element-635">
                        First Name
                      </label>
                      <input type="text" className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875]" placeholder="John" data-id="element-636" />
                    </div>
                    <div data-id="element-637">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-1" data-id="element-638">
                        Last Name
                      </label>
                      <input type="text" className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875]" placeholder="Doe" data-id="element-639" />
                    </div>
                  </div>
                  <div data-id="element-640">
                    <label className="block text-sm font-medium text-[#f2efeb]/80 mb-1" data-id="element-641">
                      Email
                    </label>
                    <input type="email" className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875]" placeholder="john@example.com" data-id="element-642" />
                  </div>
                  <div data-id="element-643">
                    <label className="block text-sm font-medium text-[#f2efeb]/80 mb-1" data-id="element-644">
                      Message
                    </label>
                    <textarea className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875] h-24 resize-none" placeholder="How can we help you?" data-id="element-645"></textarea>
                  </div>
                  <button type="button" className="w-full bg-[#c9a875] text-white font-medium py-4 px-6 rounded-full hover:bg-[#b08e5c] transition-colors flex items-center justify-center gap-2" data-id="element-646">
                    Send Message
                    <ArrowRightIcon className="w-5 h-5" data-id="element-647" />
                  </button>
                </form>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#c9a875]/10 rounded-full blur-2xl -z-10" data-id="element-648" />
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#c9a875]/10 rounded-full blur-2xl -z-10" data-id="element-649" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};